import React, { useContext, useEffect } from 'react';
import { Button } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../../actions';
import { DesignContext } from '../../../containers/GraphicBuilder/GraphicBuilder';
// import * as filterConvert from './FilterConvert';
import FilterPresets from './FilterPresets.json';
import { useTranslation } from 'react-i18next';
import './FilterPanel.css';

const FilterPanel = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { activePageRef } = useContext(DesignContext);
  const selectedEntity = useSelector(state => state.design.selectedEntity);

  useEffect(() => {
    document.querySelector('.wpCover').classList.add('active');
    return () => {
      document.querySelector('.wpCover').classList.remove('active');
    };
  }, []);

  const toggleFilter = code => {
    if (selectedEntity.type === 'Image' || selectedEntity.type === 'ImageBackground') {
      const filter = { code: code };
      dispatch(designActions.changeImageFilter(activePageRef.current, selectedEntity.id, filter));
    } else {
      const filter = { medias: { style: { filter: { code: code } } } };
      dispatch(designActions.changeFrameData(activePageRef.current, selectedEntity.id, filter));
    }
  };

  const handleClose = () => {
    dispatch(designActions.showFilterPanel(false));
  };

  const text = {
    none: t('none'),
    epic: 'Epic',
    festival: 'Festival',
    summer: 'Summer',
    afterglow: 'Afterglow',
    solar: 'Solar',
    selfie: 'Selfie',
    cali: 'Cali',
    theBlues: 'The blues',
    nordic: 'Nordic',
    whimsical: 'Whimsical',
    retro: 'Retro',
    edge: 'Edge',
    dalliance: 'Dalliance',
    peony: 'Peony',
    dare: 'Dare',
    rosie: 'Rosie',
    drama: 'Drama',
    greyscale: 'Greyscale',
    street: 'Street',
  };

  return (
    <>
      <div className="panelsCloseStrip" onClick={handleClose}></div>
      <div className="filterPanelHolder">
        <div className="header">
          <span className="closeIcon btn left" onClick={handleClose}></span>
        </div>
        <div className="content">
          <div className="bottomShade"></div>
          <div className="presetBox">
            {FilterPresets.presets.map((item, index) => (
              <Button
                key={index}
                className="button"
                title={item.name}
                value={item.code}
                onMouseDown={() => toggleFilter(item.code)}
              >
                <img alt="" src={require(`../../../assets/images/filters/${item.name}.jpg`)} />
                <span>{text[item.name]}</span>
              </Button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterPanel;
